module.exports = __webpack_public_path__ + "img/triangle-bleu.6947e053.png";